import { render, staticRenderFns } from "./OrdersForm.vue?vue&type=template&id=32a083a1&scoped=true&"
import script from "./OrdersForm.vue?vue&type=script&lang=js&"
export * from "./OrdersForm.vue?vue&type=script&lang=js&"
import style0 from "./OrdersForm.vue?vue&type=style&index=0&id=32a083a1&lang=scss&scoped=true&"
import style1 from "./OrdersForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a083a1",
  null
  
)

export default component.exports